const getTrullyText = (text) => {
  if (text === 'true' || text === true) return 'Sí';
  if (!text || text === 'false') return 'No';
  return text;
};

export default { getTrullyText };
